import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { pointsToLevel } from "@/lib/api";
import { Blueberry } from "@/components/Blueberry";
import { QuestGradePopup } from "@/components/QuestGradePopup";
import {
    ArrowLeft,
    Plus,
    BookOpen,
    Trash2,
    CheckCircle2,
    Hourglass,
    Sparkles,
} from "lucide-react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const QUEST_TYPES = [
    { value: "assignment", label: "Assignment", emoji: "📚" },
    { value: "project", label: "Project", emoji: "🎨" },
    { value: "exam", label: "Exam", emoji: "📝" },
    { value: "quiz", label: "Quiz", emoji: "❓" },
    { value: "chore", label: "Chore", emoji: "🔥" },

];

const GRADE_INFO = {
    1: { label: "Needs Work", color: "#ff3b3b", emoji: "🚩", expression: "I believe in you",},
    2: { label: "Average", color: "#ff9f1c", emoji: "🙂", expression: "You did well, but I KNOW you can do better!" },
    3: { label: "Above Average", color: "#7cc1ff", emoji: "🌟", expression: "You're magical!" },
    4: { label: "Exceptional", color: "#ffd166", emoji: "✨", expression: "You are exceptionally purrrrrr-fect!" },
};

const Quests = () => {
    const { childId } = useParams();
    const navigate = useNavigate();

    const [child, setChild] = useState(null);
    const [quests, setQuests] = useState([]);
    const [parentMode, setParentMode] = useState(false);
    const [createOpen, setCreateOpen] = useState(false);
    const [gradeOpen, setGradeOpen] = useState(null);
    const [editQuest, setEditQuest] = useState(null);
    const [confetti, setConfetti] = useState(false);
    const [celebrate, setCelebrate] = useState("");
    const [expression, setExpression] = useState("neutral");
    const [reminder, setReminder] = useState("");
    const [popup, setPopup] = useState(null);
    const [gradePopup, setGradePopup] = useState(null);
    const [selectedQuestDetails, setSelectedQuestDetails] = useState(null);
    const load = useCallback(() => {
        const savedChildren = JSON.parse(
            localStorage.getItem("shadowGroveChildren") || "[]"
        );

        const savedChild =
    savedChildren.find((c) => c.child_id === childId) || null;


        setChild({
            child_id: savedChild?.child_id || childId,
            name: savedChild?.name || "Blueberry",
            title: savedChild?.title || "witch",
            points: savedChild?.points || 120,
            coins: savedChild?.coins || 50,
            gems: savedChild?.gems || 5,
            hunger: savedChild?.hunger || 85,
            inventory: savedChild?.inventory || [],
            equipped: savedChild?.equipped || {},
            equipped_positions: savedChild?.equipped_positions || {},
        });
        const savedEvents = JSON.parse(
    localStorage.getItem("shadowGroveEvents") || "[]"
);
const classroomQuests = savedEvents
    .filter((event) => event.child_id === childId && !event.archived)
    .map((event) => ({
        ...event,
        id: event.id,
        quest_id: event.id,
        name: event.title,
        subject: event.subject_name,
        quest_type: event.type,
        base_points: event.points || 0,
        due_date: event.date_start,
        rubric_enabled: event.rubric_enabled,
rubric_rows: event.rubric_rows || [],
rubric_total_points: event.rubric_total_points || 100,
    }));

setQuests(classroomQuests);

    }, [childId]);

    useEffect(() => {
        load();
    }, [load]);
    useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const urgentQuest = quests.find((q) => {
        if (q.status !== "open") return false;
        if (!q.due_date) return false;

        const [year, month, day] = q.due_date.split("-");
        const due = new Date(year, month - 1, day);

        due.setHours(0, 0, 0, 0);

        const diffDays = Math.round((due - today) / 86400000);

        return diffDays >= 0 && diffDays <= 1;
    });

    if (!urgentQuest) {
        setReminder("");
        return;
    }

    const [year, month, day] = urgentQuest.due_date.split("-");
const due = new Date(year, month - 1, day);

    due.setHours(0, 0, 0, 0);

    const diffDays = Math.round((due - today) / 86400000);

    setReminder(
        diffDays === 0
            ? `${urgentQuest.name} is due today!`
            : `${urgentQuest.name} is due tomorrow!`
    );
}, [quests]);

    useEffect(() => {
    setPopup(null);

    const savedNotifications = JSON.parse(
        localStorage.getItem("shadowGroveNotifications") || "[]"
    );

    const nextPopup = savedNotifications.find(
        (n) => n.child_id === childId && !n.seen
    );

    if (nextPopup) {
        setGradePopup(nextPopup);
    }
}, [childId]);

    const completeQuest = (q) => {
    const savedEvents = JSON.parse(
        localStorage.getItem("shadowGroveEvents") || "[]"
    );

   const updatedEvents = savedEvents.map((event) =>
    event.id === q.quest_id
        ? {
              ...event,
              status: "pending_approval",
              submitted_at: new Date().toISOString(),
              submitted_by: childId,
          }
        : event
);

    localStorage.setItem("shadowGroveEvents", JSON.stringify(updatedEvents));

    setConfetti(true);
    setCelebrate("bb-celebrate-dance");

    setTimeout(() => {
        setConfetti(false);
        setCelebrate("");
    }, 2400);

    const submittedQuest = updatedEvents.find(
    (event) => event.id === q.quest_id
);

console.log("SUBMITTED QUEST:", submittedQuest);

toast.success("Quest sent for parent approval!");
    load();
};

if (!child) {
    return (
        <div style={{ color: "white", padding: 40 }}>
            Quest page loading child...
        </div>
    );
}

const lvl = pointsToLevel(child.points);

const sortByDate = (arr) =>
    [...arr].sort((a, b) => {
        if (!a.due_date) return 1;
        if (!b.due_date) return -1;

        const [aYear, aMonth, aDay] = a.due_date.split("-");
        const [bYear, bMonth, bDay] = b.due_date.split("-");

        const aDate = new Date(aYear, aMonth - 1, aDay);
        const bDate = new Date(bYear, bMonth - 1, bDay);

        return aDate - bDate;
    });




const open = sortByDate(
    quests.filter((q) => q.status === "open" && q.quest_type !== "chore")
);


const pending = sortByDate(
    quests.filter(
        (q) =>
            (q.status === "pending_approval" || q.status === "pending_approval") &&
            q.quest_type !== "chore"
    )
);

const graded = quests.filter(
    (q) =>
        (q.status === "graded" ||
            q.status === "completed" ||
            q.status === "try_again") &&
        q.quest_type !== "chore"
);


    return (
        <div className="relative min-h-screen overflow-hidden bg-[#05070d] text-[#f3e8ff]">


            <header className="relative z-10 border-b border-[var(--bb-border)]">
    <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between gap-3">
        <button
            onClick={() => navigate(`/child/home/${childId}`)}
            className="
    !inline-flex
    !items-center
    !justify-center
    !gap-2
    !rounded-xl
    !bg-[#7c3aed]/25
    !border
    !border-[#7c3aed]/55
    !text-[#f3e8ff]
    !px-3
    !py-2
    !text-xs
    !font-semibold
    hover:!border-[#ffd166]/85
    hover:!bg-[#7c3aed]/35
    hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]
"
            data-testid="quests-back"
        >
            <ArrowLeft size={16} /> Working desk
        </button>

        <div className="text-center min-w-0">
            <p className="text-xs uppercase tracking-[0.2em] text-[#6c7a9c]">
                {child.name}'s
            </p>

            <h1 className="font-display text-2xl flex items-center gap-2 justify-center">
                <BookOpen size={20} className="text-[#b388ff]" />
                Quest desk
            </h1>
        </div>

        <div className="flex items-center gap-2">
            <button
                onClick={() => navigate(`/codex/${childId}`)}
                className="
    !inline-flex
    !items-center
    !justify-center
    !gap-2
    !rounded-xl
    !bg-[#7c3aed]/25
    !border
    !border-[#7c3aed]/55
    !text-[#f3e8ff]
    !px-3
    !py-2
    !text-xs
    !font-semibold
    hover:!border-[#ffd166]/85
    hover:!bg-[#7c3aed]/35
    hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]
"
            >
                <BookOpen size={16} /> Codex
            </button>
            
            <button
    onClick={() => navigate(`/child/home/${childId}?desk=chores`)}
    className="
    !inline-flex
    !items-center
    !justify-center
    !gap-2
    !rounded-xl
    !bg-[#7c3aed]/25
    !border
    !border-[#7c3aed]/55
    !text-[#f3e8ff]
    !px-3
    !py-2
    !text-xs
    !font-semibold
    hover:!border-[#ffd166]/85
    hover:!bg-[#7c3aed]/35
    hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]
"
>
    Household Duties
</button>

          <button
    onClick={() => setParentMode(!parentMode)}
   className="
    !inline-flex
    !items-center
    !justify-center
    !gap-2
    !rounded-xl
    !bg-[#7c3aed]/25
    !border
    !border-[#7c3aed]/55
    !text-[#f3e8ff]
    !px-3
    !py-2
    !text-xs
    !font-semibold
    hover:!border-[#ffd166]/85
    hover:!bg-[#7c3aed]/35
    hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]
"
    data-testid="parent-mode-toggle"
>
    {parentMode ? "Exit parent" : "Parent mode"}
</button>

        </div>
    </div>
</header>

            <section className="relative z-10 flex flex-col items-center pt-8 pb-12">
                <div className="relative">
                    <Blueberry
                        level={lvl}
                        size={210}
                        equipped={child.equipped}
                        celebrateClass={celebrate}
                        expression={expression}
                    />
                </div>

                <p className="mt-8 text-[#b0b8d6] text-sm max-w-md text-center px-6">
                    
                </p>
                {reminder && (
    <div className="mt-4 bb-card px-4 py-3 max-w-md text-center border border-[#ffd166]/30">
        <p className="text-sm text-[#ffd166]">
            🌙 Blueberry says: {reminder}
        </p>
    </div>
)}
            </section>

            <main className="relative z-10 max-w-6xl mx-auto px-6 pb-24 space-y-10">
    {parentMode && (
        <div className="flex justify-end">
            <button
                onClick={() => {
                    setEditQuest(null);
                    setCreateOpen(true);
                }}
                className="bb-btn-primary flex items-center gap-2"
                data-testid="create-quest-btn"
            >
                <Plus size={16} /> New quest
            </button>
        </div>
    )}

    <Section
        title="Open quests"
        color="#7cc1ff"
        empty="No quests yet. Ask a parent to create some."
        items={open}
        render={(q) => (
            <QuestCard
                key={q.quest_id}
                q={q}
                parentMode={parentMode}
                onComplete={() => completeQuest(q)}
                onViewDetails={() => setSelectedQuestDetails(q)}
                onEdit={() => {
                    setEditQuest(q);
                    setCreateOpen(true);
                    
                }}
               onDelete={() => {
    const savedEvents = JSON.parse(
        localStorage.getItem("shadowGroveEvents") || "[]"
    );

    const updatedEvents = savedEvents.filter(
        (event) => event.id !== q.quest_id
    );

    localStorage.setItem(
        "shadowGroveEvents",
        JSON.stringify(updatedEvents)
    );

    toast.success("Quest deleted");
    load();
}} 

            />
        )}
    />

    <Section
        title="Pending parent approval"
        color="#ffd166"
        empty="Nothing waiting."
        items={pending}
        render={(q) => (
            <QuestCard
                key={q.quest_id}
                q={q}
                parentMode={parentMode}
                onGrade={parentMode ? () => setGradeOpen(q) : null}
               onDelete={() => {
    const savedEvents = JSON.parse(
        localStorage.getItem("shadowGroveEvents") || "[]"
    );

    const updatedEvents = savedEvents.filter(
        (event) => event.id !== q.quest_id
    );

    localStorage.setItem(
        "shadowGroveEvents",
        JSON.stringify(updatedEvents)
    );

    toast.success("Quest deleted");
    load();
}}

            />
        )}
    />

    <Section
        title="Graded"
        color="#b388ff"
        empty="No graded quests yet."
        items={graded}
        render={(q) => (
            <QuestCard
                key={q.quest_id}
                q={q}
                parentMode={parentMode}
                onDelete={() => {
    const savedQuests = JSON.parse(
        localStorage.getItem("shadowGroveEvents") || "[]"
    );


    const updated = savedQuests.filter(
        (quest) => quest.quest_id !== q.quest_id
    );


    localStorage.setItem(
        "shadowGroveEvents",
        JSON.stringify(updated)
    );


    toast.success("Quest deleted");


    load();
}}

            />
        )}
    />
</main>

            {parentMode && createOpen && (
                <CreateQuestDialog
                    open={createOpen}
                    onOpenChange={(v) => {
                        setCreateOpen(v);
                        if (!v) setEditQuest(null);
    }}
    childId={childId}
    editQuest={editQuest}
    onSaved={load}
/>

            )}

            {parentMode && gradeOpen && (
                <GradeQuestDialog
                    quest={gradeOpen}
                    onOpenChange={() => setGradeOpen(null)}
                    onGraded={(grade) => {
                        setExpression(GRADE_INFO[grade].expression);

                        if (grade === 4) {
                        setCelebrate("bb-celebrate-dance bb-celebrate-big");
                        } else if (grade === 3) {
                            setCelebrate("bb-celebrate-dance");
                        }

                        setTimeout(() => {
                            setExpression("neutral");
                            setCelebrate("");
                        }, 2500);

                        load();
                    }}
                />
            )}
            {gradePopup && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 p-4">
      
        <div className="bb-card w-full max-w-md p-6 text-center border border-[#ffd166]/50 shadow-[0_0_35px_rgba(255,209,102,0.25)] animate-in fade-in zoom-in">
            <div className="text-6xl mb-4">
                {gradePopup.result !== "try_again" && <StarSparkleBurst />}
                {gradePopup.result === "try_again" ? "😿" : "✨"}
            </div>

            <h2 className="font-display text-3xl text-[#ffd166] mb-2">
                {gradePopup.result === "try_again"
                    ? "Try Again"
                    : "Quest Approved"}
            </h2>

            <p className="text-sm text-[#b0b8d6] mb-3">
                {gradePopup.quest_name}
            </p>

            <div className="rounded-2xl border border-[#ffd166]/30 bg-[#080b14]/90 p-4 mb-4">
                <p className="text-sm text-[#ffd166]">
                    Grade: {gradePopup.grade}
                </p>

                <p className="text-sm text-[#7dffb2] mt-1">
                    Award: {gradePopup.awarded || 0} points
                </p>

                {gradePopup.note && (
                    <p className="text-sm text-[#b0b8d6] italic mt-3">
                        "{gradePopup.note}"
                    </p>
                )}
                
            </div>

            <p className="text-sm text-[#b0b8d6] mb-5">
                {gradePopup.result !== "try_again" && <StarSparkleBurst />}
                {gradePopup.result === "try_again"
                    ? "Blueberry believes in you. Review the note and try again."
                    : "Great work!"}
            </p>

            <button
                className={gradePopup.result === "try_again" ? "bb-btn-ghost" : "bb-btn-primary"}
                onClick={() => {
                    const savedNotifications = JSON.parse(
                        localStorage.getItem("shadowGroveNotifications") || "[]"
                    );

                    const updated = savedNotifications.map((n) =>
                        n.id === gradePopup.id
                            ? { ...n, seen: true }
                            : n
                    );

                    localStorage.setItem(
                        "shadowGroveNotifications",
                        JSON.stringify(updated)
                    );

                    const next = updated.find(
                        (n) => n.child_id === childId && !n.seen
                    );

                    setGradePopup(next || null);
                }}
            >
                Continue
            </button>
            
        </div>
        
    </div>
    
)}
{selectedQuestDetails && (
    <div className="fixed inset-0 z-50 bg-black/75 flex items-center justify-center p-4">
        <div className="w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-[32px] border border-[#ffd166]/50 bg-black p-6 shadow-[0_0_35px_rgba(255,209,102,0.25)]">

            <div className="flex items-start justify-between gap-4">
                <div>
                    <h2 className="font-display text-3xl text-[#ffd166]">
                        {selectedQuestDetails.name}
                    </h2>

                    <p className="text-sm text-[#b0b8d6] mt-1">
                        {selectedQuestDetails.subject}
                    </p>
                </div>

                <button
                    onClick={() => setSelectedQuestDetails(null)}
                    className="!inline-flex !items-center !justify-center !gap-2 !rounded-xl !bg-[#7c3aed]/25 !border !border-[#7c3aed]/55 !text-[#f3e8ff] !px-3 !py-2 !text-xs !font-semibold hover:!border-[#ffd166]/85 hover:!bg-[#7c3aed]/35 hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]"
                >
                    Close
                </button>
            </div>
                <div className="mt-6 rounded-2xl border border-[#ffd166]/30 bg-[#080b14]/90 p-4">
    <h3 className="font-display text-xl text-[#ffd166] mb-2">
        Debug Details
    </h3>

    <p className="text-xs text-[#b0b8d6]">
        Description: {selectedQuestDetails.description ? "yes" : "no"}
    </p>

    <p className="text-xs text-[#b0b8d6]">
        Rubric Enabled: {selectedQuestDetails.rubric_enabled ? "yes" : "no"}
    </p>

    <p className="text-xs text-[#b0b8d6]">
        Rubric Rows: {selectedQuestDetails.rubric_rows?.length || 0}
    </p>

    <p className="text-xs text-[#b0b8d6]">
        Breakdown Steps: {selectedQuestDetails.quest_breakdown_steps?.length || 0}
    </p>
</div>

            {selectedQuestDetails.description && (
                <div className="mt-6 rounded-2xl border border-[#ffd166]/30 bg-[#080b14]/90 p-4">
                    <h3 className="font-display text-xl text-[#ffd166] mb-2">
                        Assignment Details
                    </h3>

                    <p className="text-sm text-[#e6ecff] whitespace-pre-wrap">
                        {selectedQuestDetails.description}
                    </p>
                </div>
            )}

            {selectedQuestDetails.link && (
                <div className="mt-4">
                    <a
                        href={selectedQuestDetails.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bb-btn-primary inline-flex"
                    >
                        Open Assignment Link
                    </a>
                </div>
            )}

            {selectedQuestDetails.quest_breakdown_enabled &&
                selectedQuestDetails.quest_breakdown_steps?.length > 0 && (
                    <div className="mt-6 rounded-2xl border border-[#ffd166]/30 bg-[#080b14]/90 p-4">
                        <h3 className="font-display text-xl text-[#ffd166] mb-3">
                            Quest Breakdown
                        </h3>

                        <div className="space-y-2">
                            {selectedQuestDetails.quest_breakdown_steps.map((step) => (
                                <div
                                    key={step.id}
                                    className="rounded-xl border border-[#ffd166]/20 px-3 py-2"
                                >
                                    <p className="text-sm text-[#e6ecff]">
                                        {step.title}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            {selectedQuestDetails.rubric_enabled && (
                <div className="mt-6 rounded-2xl border border-[#ffd166]/30 bg-[#080b14]/90 p-4">
                    <h3 className="font-display text-xl text-[#ffd166] mb-3">
                        Grading Rubric
                    </h3>

                    <div className="space-y-2">
                        {selectedQuestDetails.rubric_rows?.map((row) => (
                            <div
                                key={row.id}
                                className="flex items-center justify-between rounded-xl border border-[#ffd166]/20 px-3 py-2"
                            >
                                <span className="text-sm text-[#e6ecff]">
                                    {row.criteria}
                                </span>

                                <span className="text-sm text-[#ffd166]">
                                    {row.maxPoints} pts
                                </span>
                            </div>
                        ))}
                    </div>

                    <p className="text-xs text-[#6c7a9c] mt-3">
                        Total Possible: {selectedQuestDetails.rubric_total_points} points
                    </p>
                </div>
            )}
        </div>
    </div>
)}
            
        </div>
    );
};




const Section = ({ title, color, items, empty, render }) => (
    <section>
        <h2 className="font-display text-2xl mb-3" style={{ color }}>
            {title}{" "}
            <span className="text-sm text-[#6c7a9c] font-normal">
                ({items.length})
            </span>
        </h2>

        {items.length === 0 ? (
            <p className="text-[#6c7a9c] text-sm bb-card p-4">{empty}</p>
        ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {items.map(render)}
            </div>
        )}
    </section>
);

const QuestCard = ({ q, parentMode, onComplete, onGrade, onEdit, onDelete, onViewDetails }) => {
    const t =
        QUEST_TYPES.find((x) => x.value === q.quest_type) ||
        QUEST_TYPES[0];

    return (
        <article
    className="
        rounded-[28px]
        border border-[#ffd166]/35
        bg-black
        p-4
        shadow-[0_0_22px_rgba(255,209,102,0.10)]
        group flex flex-col gap-2
        transition-all duration-200
        hover:border-[#ffd166]/70
        hover:shadow-[0_0_28px_rgba(255,209,102,0.20)]
    "
            data-testid={`quest-${q.quest_id}`}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                    <p className="text-xs uppercase tracking-widest text-[#6c7a9c]">
                        {t.emoji} {t.label} · {q.subject}
                    </p>

                    <h3 className="font-display text-lg truncate">
                        {q.name}
                    </h3>
                </div>

                <span className="px-3 py-1 rounded-full text-xs font-bold border border-[#ffd166]/40 bg-[#7c3aed]/20 text-[#ffd166] shadow-[0_0_12px_rgba(255,209,102,0.10)]">
                    {q.base_points}p
                </span>
            </div>

            {q.description && (
                    <p className="text-sm text-[#d7def7] leading-relaxed">
                    {q.description}
                </p>
                
            )}
            {q.rubric_enabled && (
    <div className="mt-3 rounded-2xl border border-[#ffd166]/30 bg-[#080b14]/90 p-3">
        <h4 className="font-display text-lg text-[#ffd166] mb-2">
            Grading Rubric
        </h4>

        <div className="space-y-2">
            {q.rubric_rows?.map((row) => (
                <div
                    key={row.id}
                    className="flex items-center justify-between rounded-xl border border-[#ffd166]/20 px-3 py-2"
                >
                    <span className="text-sm text-[#e6ecff]">
                        {row.criteria}
                    </span>

                    <span className="text-sm text-[#ffd166]">
                        {row.maxPoints} pts
                    </span>
                </div>
            ))}
        </div>

        <p className="text-xs text-[#6c7a9c] mt-3">
            Total Possible: {q.rubric_total_points} points
        </p>
    </div>
)}
            {q.link && (
    <a
        href={q.link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-[#7cc1ff] underline"
    >
        Open assignment link
    </a>
)}

            {q.due_date && (
    <p className="text-xs text-[#ffd166] mt-1">
        Due:{" "}
            {q.due_date}

    </p>
)}
        {q.due_date &&
    q.status === "open" &&
    (() => {
        const [year, month, day] = q.due_date.split("-");


        const dueDate = new Date(year, month - 1, day);


        const today = new Date();
        today.setHours(0, 0, 0, 0);


        return dueDate < today;
    })() && (
        <p className="text-xs text-red-400 mt-1 font-bold">
            ⚠ Late
        </p>
)}



            {(q.status === "graded" ||
                q.status === "completed" ||
                 q.status === "try_again") && (
                <div className="text-xs px-3 py-3 rounded-2xl border border-[#ffd166]/20 bg-[#080b14]/90">
                    Grade {q.grade} · earned <b>{q.awarded_points || 0}</b>p
                    {q.rubric_results?.length > 0 && (
    <div className="mt-3 rounded-2xl border border-[#ffd166]/20 bg-black p-3">
        <p className="text-xs text-[#ffd166] mb-2">
            Rubric Results
        </p>

        <div className="space-y-2">
            {q.rubric_results.map((row) => (
                <div
                    key={row.id}
                    className="flex items-center justify-between text-xs border border-[#ffd166]/10 rounded-xl px-2 py-1"
                >
                    <span className="text-[#b0b8d6]">
                        {row.criteria}
                    </span>

                    <span className="text-[#ffd166]">
                        {row.earnedPoints || 0} / {row.maxPoints}
                    </span>
                </div>
            ))}
        </div>

        <p className="text-xs text-[#7dffb2] mt-3">
            Total: {q.rubric_total_earned || 0} · {q.rubric_percentage || 0}%
        </p>
    </div>
)}
                    {q.parent_message && (
                        <p className="mt-1 italic text-[#b0b8d6]">
                            q.parent_note
                        </p>
                    )}
                </div>
            )}

            <div className="mt-auto flex justify-end gap-2">
                {q.status === "open" && !parentMode && (
                    <button
                        onClick={onComplete}
                        className="
    !inline-flex
    !items-center
    !gap-1
    !rounded-xl
    !bg-[#7c3aed]/25
    !border
    !border-[#7c3aed]/55
    !text-[#f3e8ff]
    !px-3
    !py-2
    !text-xs
    !font-semibold
    hover:!border-[#ffd166]/85
    hover:!bg-[#7c3aed]/35
    hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]
"
                    >
                        <CheckCircle2 size={12} />
                        Mark done
                    </button>
                )}
                    {onViewDetails && (
    <button
        onClick={onViewDetails}
        className="bb-btn-ghost !text-xs"
    >
        View Details
    </button>
)}
                {(q.status === "pending" || q.status === "pending_approval") && !parentMode && (
                    <span className="text-xs text-[#ffd166] flex items-center gap-1">
                        <Hourglass size={12} />
                        Awaiting grade
                    </span>
                )}

                {parentMode &&
    (q.status === "pending" || q.status === "pending_approval") &&
    onGrade && (
                    <button
                        onClick={onGrade}
                        className="bb-btn-coven !text-xs"
                    >
                        Grade
                    </button>
                )}
            {parentMode && q.status === "open" && onEdit && (
    <button
        onClick={onEdit}
        className="bb-btn-coven !text-xs"
    >
        Edit
    </button>
)}
                {parentMode && onDelete && (
                    <button
                        onClick={onDelete}
                        className="bb-btn-ghost !p-2 hover:!text-red-400"
                    >
                        <Trash2 size={14} />
                    </button>
                )}
            </div>
        </article>
    );
};

const CreateQuestDialog = ({ open, onOpenChange, childId, editQuest, onSaved }) => {
const [subject, setSubject] = useState("");
const [name, setName] = useState("");
const [description, setDescription] = useState("");
const [questType, setQuestType] = useState("assignment");
const [points, setPoints] = useState(20);
const [dueDate, setDueDate] = useState("");
const [link, setLink] = useState("");
const [classes, setClasses] = useState(() =>
    JSON.parse(localStorage.getItem("shadowGroveClasses") || "[]")
);

const [newClassName, setNewClassName] = useState("");
useEffect(() => {
    if (!editQuest) return;


    setSubject(editQuest.subject || "");
    setName(editQuest.name || "");
    setDescription(editQuest.description || "");
    setQuestType(editQuest.quest_type || "assignment");
    setPoints(editQuest.base_points || 20);
    setDueDate(editQuest.due_date || "");
    setLink(editQuest.link || "");
}, [editQuest]);

const addClass = () => {
    const cleanName = newClassName.trim();
        
    if (!cleanName) {
        toast.error("Class name required");
        return;
    }

    const updatedClasses = [...classes, cleanName];

    localStorage.setItem(
        "shadowGroveClasses",
        JSON.stringify(updatedClasses)
    );

    setClasses(updatedClasses);
    setSubject(cleanName);
    setNewClassName("");

    toast.success("Class added");
};

const save = () => {
    if (!subject.trim() || !name.trim()) {
        toast.error("Class and quest name required");
        return;
    }

    const newQuest = {
        quest_id: Date.now().toString(),
        child_id: childId,
        subject: subject.trim(),
        name: name.trim(),
        description: description.trim(),
        quest_type: questType,
        base_points: Number(points) || 10,
        due_date: dueDate,
        status: "open",
        created_at: new Date().toISOString(),
        link: link.trim(),
    };

    const savedQuests = JSON.parse(
        localStorage.getItem("shadowGroveEvents") || "[]"
    );

    const updatedQuests = editQuest
    ? savedQuests.map((q) =>
          q.quest_id === editQuest.quest_id
              ? {
                    ...q,
                    subject: subject.trim(),
                    name: name.trim(),
                    description: description.trim(),
                    quest_type: questType,
                    base_points: Number(points) || 10,
                    due_date: dueDate,
                    link: link.trim(),
                }
              : q
      )
    : [...savedQuests, newQuest];

    localStorage.setItem(
        "shadowGroveEvents",
        JSON.stringify(updatedQuests)
    );

    toast.success("Quest Conjured");

    onSaved();
    onOpenChange(false);

    setSubject("");
    setName("");
    setDescription("");
    setPoints(20);
    setDueDate("");
    setLink("");
};


    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-[#12182b] border border-[var(--bb-border)] text-white max-h-[85vh] overflow-y-auto">

                <DialogHeader>
                    <DialogTitle className="font-display text-2xl">
                        New quest
                    </DialogTitle>

                    <DialogDescription className="text-[#b0b8d6]">
                        Create an assignment, project, exam, or quiz.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid grid-cols-2 gap-3 py-2">
                    <div>
    <Label>Class</Label>

    <select
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        className="mt-1 w-full bg-[#080b14] border border-[#1f2942] rounded-md px-3 py-2"
    >
        <option value="">Select class</option>

        {classes.map((c) => (
            <option key={c} value={c}>
                {c}
            </option>
        ))}
    </select>
</div>

<div>
    <Label>New class</Label>

    <div className="flex gap-2 mt-1">
        <Input
            value={newClassName}
            onChange={(e) => setNewClassName(e.target.value)}
            placeholder="Astronomy"
            className="bg-[#080b14] border-[#1f2942]"
        />

        <button
            type="button"
            onClick={addClass}
            className="bb-btn-coven whitespace-nowrap"
        >
            Add
        </button>
    </div>
</div>

                    <div>
                        <Label>Type</Label>

                        <select
                            value={questType}
                            onChange={(e) => setQuestType(e.target.value)}
                            className="mt-1 w-full bg-[#080b14] border border-[#1f2942] rounded-md px-3 py-2"
                        >
                            {QUEST_TYPES.map((t) => (
                                <option key={t.value} value={t.value}>
                                    {t.emoji} {t.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-span-2">
                        <Label>Quest name</Label>

                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Chapter 5 worksheet"
                            className="mt-1 bg-[#080b14] border-[#1f2942]"
                        />
                    </div>

                    <div className="col-span-2">
    <Label>Description</Label>

    <Textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        rows={3}
        placeholder="Show your work."
        className="mt-1 bg-[#080b14] border-[#1f2942]"
    />
</div>

<div className="col-span-2">
    <Label>Assignment link</Label>

    <Input
        value={link}
        onChange={(e) => setLink(e.target.value)}
        placeholder="https://classroom.google.com/..."
        className="mt-1 bg-[#080b14] border-[#1f2942]"
    />
</div>
                
                    <div>
                        <Label>Base points</Label>

                        <Input
                            type="number"
                            value={points}
                            onChange={(e) => setPoints(e.target.value)}
                            className="mt-1 bg-[#080b14] border-[#1f2942]"
                        />
                    </div>
                </div>
                <div>
    <Label>Due date</Label>

    <Input
        type="date"
        value={dueDate}
        onChange={(e) => setDueDate(e.target.value)}
        className="mt-1 bg-[#080b14] border-[#1f2942]"
    />
        </div>
                <DialogFooter>
                    <button
                        onClick={() => onOpenChange(false)}
                        className="!inline-flex !items-center !justify-center !gap-2 !rounded-xl !bg-[#7c3aed]/25 !border !border-[#7c3aed]/55 !text-[#f3e8ff] !px-3 !py-2 !text-xs !font-semibold hover:!border-[#ffd166]/85 hover:!bg-[#7c3aed]/35 hover:!shadow-[0_0_12px_rgba(255,209,102,0.28)]"
                    >
                        Cancel
                    </button>

                    <button onClick={save} className="bb-btn-primary">
                        Save quest
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

const GradeQuestDialog = ({ quest, onOpenChange, onGraded }) => {
    const [grade, setGrade] = useState(3);
    const [message, setMessage] = useState("");
    const rewardRules = {
    1: {
        pointMultiplier: 0,
        hungerChange: -15,
    },
    2: {
        pointMultiplier: 0.25,
        hungerChange: 0,
    },
    3: {
        pointMultiplier: 0.5,
        hungerChange: 5,
    },
    4: {
        pointMultiplier: 1,
        hungerChange: 10,
    },
};

    const doSubmit = () => {
    const rule = rewardRules[grade];


        const isLate =
    quest.due_date &&
    (() => {
        const [year, month, day] = quest.due_date.split("-");


        const dueDate = new Date(year, month - 1, day);


        const today = new Date();
        today.setHours(0, 0, 0, 0);


        return dueDate < today;
    })();




const latePenaltyMultiplier =
    isLate && (grade === 3 || grade === 4)
        ? 0.5
        : 1;

       

const awarded = Math.round(
    quest.base_points *
        rule.pointMultiplier *
        latePenaltyMultiplier
);

        const savedQuests = JSON.parse(
            localStorage.getItem("shadowGroveEvents") || "[]"
        );

        const updatedQuests = savedQuests.map((q) =>
            q.quest_id === quest.quest_id
                ? {
                      ...q,
                      status: "graded",
                      grade,
                      parent_message: message,
                      awarded_points: awarded,
                      graded_at: new Date().toISOString(),
                  }
                : q
        );

        localStorage.setItem(
            "shadowGroveEvents",
            JSON.stringify(updatedQuests)
        );

        const savedChildren = JSON.parse(
            localStorage.getItem("shadowGroveChildren") || "[]"
        );

        const updatedChildren = savedChildren.map((kid) =>
            kid.child_id === quest.child_id
                ? {
                      ...kid,
                      points: Math.max(0, (kid.points || 0) + awarded),
                      
                      hunger: Math.max(
                          0,
                          Math.min(
                              (kid.hunger || 85) + rule.hungerChange,
                              100
                          )
                      ),
                  }
                : kid
        );

        localStorage.setItem(
            "shadowGroveChildren",
            JSON.stringify(updatedChildren)
        );

        toast.success(`Awarded ${awarded} points`);
        const savedNotifications = JSON.parse(
    localStorage.getItem("shadowGroveNotifications") || "[]"
);

savedNotifications.push({
    id: Date.now().toString(),
    child_id: quest.child_id,
    quest_name: quest.name,
    grade,
    awarded,
    message,
    seen: false,
});

localStorage.setItem(
    "shadowGroveEvents",
    JSON.stringify(updatedEvents)
);     onGraded(grade);
        onOpenChange(false);
    };

    return (
        <Dialog open={!!quest} onOpenChange={onOpenChange}>
            <DialogContent className="bg-[#12182b] border border-[var(--bb-border)] text-white">
                <DialogHeader>
                    <DialogTitle className="font-display text-2xl">
                        Grade · {quest.name}
                    </DialogTitle>

                    <DialogDescription className="text-[#b0b8d6]">
                        Pick 1 through 4 for performance.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid grid-cols-4 gap-2 py-2">
                    {[1, 2, 3, 4].map((g) => {
                        const info = GRADE_INFO[g];
                        const sel = grade === g;

                        return (
                            <button
                                key={g}
                                onClick={() => setGrade(g)}
                                className={`p-3 rounded-2xl border-2 text-center transition ${
                                    sel
                                        ? "border-[#7cc1ff] bg-[#3a86ff]/10"
                                        : "border-transparent bg-white/5"
                                }`}
                            >
                                <div className="text-3xl">{info.emoji}</div>

                                <p
                                    className="text-xs mt-1 font-bold"
                                    style={{ color: info.color }}
                                >
                                    {g}/4
                                </p>

                                <p className="text-[10px] text-[#6c7a9c]">
                                    {info.label}
                                </p>
                            </button>
                        );
                    })}
                </div>
            <div className="bb-card p-3 text-sm text-[#b0b8d6]">
    <p>
        Bonding preview:{" "}
        {Math.round(
            quest.base_points *
                rewardRules[grade].pointMultiplier
        )} points
    </p>
</div>


                <div>
                    <Label>Message to child</Label>

                    <Textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        rows={2}
                        placeholder="Great effort!"
                        className="mt-1 bg-[#080b14] border-[#1f2942]"
                    />
                </div>

                <DialogFooter>
                    <button
                        onClick={() => onOpenChange(false)}
                        className="bb-btn-ghost"
                    >
                        Cancel
                    </button>

                    <button onClick={doSubmit} className="bb-btn-primary">
                        Send grade
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
const StarSparkleBurst = () => {
    const stars = Array.from({ length: 36 });

    return (
        <div className="fixed inset-0 z-40 pointer-events-none overflow-hidden">
            {stars.map((_, i) => {
                const left = Math.random() * 100;
                const top = Math.random() * 100;
                const size = 8 + Math.random() * 14;
                const delay = Math.random() * 0.6;

                return (
                    <span
                        key={i}
                        className="absolute text-[#ffd166] animate-ping"
                        style={{
                            left: `${left}%`,
                            top: `${top}%`,
                            fontSize: `${size}px`,
                            animationDelay: `${delay}s`,
                        }}
                    >
                        ✨
                    </span>
                );
            })}
        </div>
    );
};
const Confetti = () => {
    const pieces = Array.from({ length: 30 });

    return (
        <div className="fixed inset-0 z-30 pointer-events-none overflow-hidden">
            {pieces.map((_, i) => {
                const left = Math.random() * 100;
                const dur = 1.6 + Math.random() * 1.2;
                const delay = Math.random() * 0.4;

                const color = [
                    "#ffd166",
                    "#7cc1ff",
                    "#b388ff",
                    "#ff6fa1",
                ][i % 4];

                return (
                    <span
                        key={i}
                        className="absolute"
                        style={{
                            top: "-10%",
                            left: `${left}%`,
                            width: 8,
                            height: 14,
                            background: color,
                            transform: `rotate(${Math.random() * 360}deg)`,
                            animation: `bb-star-fall ${dur}s ${delay}s linear forwards`,
                            borderRadius: 2,
                        }}
                    />
                );
            })}

            <div className="absolute inset-0 flex items-center justify-center">
                <Sparkles
                    size={64}
                    className="text-[#ffd166] opacity-80 animate-pulse"
                />
            </div>
        </div>
    );
};

export default Quests;
